
import { Injectable, Optional, Inject } from "@angular/core";
import { Observable, of } from 'rxjs';

import { AppHelper } from "../../appHelper/appHelper";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpBackend } from "@angular/common/http";
import { map } from "rxjs/operators";
import { ENVIRONMENTER } from '../../../../environments/enviromenter/environmenter-token';

@Injectable({
    providedIn: 'root'
})
export class AppHelperService {

    private http: HttpClient;
    constructor(
        handler: HttpBackend,
        @Inject(ENVIRONMENTER) public environmenter: any,
        @Optional() @Inject('baseUrl') private baseUrl: string,
        @Optional() @Inject('noAppHelper') private noAppHelper: boolean) {

        this.http = new HttpClient(handler);//to avoid being intercept
    }


    GetAppHelper(): Observable<any> {
        this.noAppHelper = false;
        if (this.noAppHelper) {
            // console.log('**Using environment instead of appHelper.json**');
            this.setAppHelper(this.environmenter);
            return of(this.environmenter);
        } else {

            var appHelperUrl: string = `/assets/data/appHelper.json`;
            if (this.baseUrl) {
                appHelperUrl = this.baseUrl + appHelperUrl;
            }

            return this.http.get(appHelperUrl).pipe(map((data: any) => {
                this.setAppHelper(data);
                return data;
            }));
        }
    }


    private setAppHelper(data: any) {
        /*
        "FTPUrl": "http://localhost:4202/services/",
        "BaseUrl": "http://localhost:4202/services/api/",
        "SSoBaseUrl": "http://localhost:4202/auth",
        "SSoApi": "http://localhost:4202/auth/api",
        "signalR_Url": "http://localhost:4202/services/SocketUser",
        */

        AppHelper.SiteUrl = data.SiteUrl;
        AppHelper.FTPUrl = `${data.SiteUrl}/services/`;
        if (!this.baseUrl)
            AppHelper.FTPUrl = `${data.ServicesUrl}/`;

        AppHelper.BaseUrl = `${data.ServicesUrl}/api/`;
        AppHelper.signalR_Url = `${data.ServicesUrl}/SocketUser/`;
        AppHelper.SSoBaseUrl = `${data.AuthUrl}/`;
        AppHelper.SSoApi = `${data.AuthUrl}/api/`;
        AppHelper.adminLayout = data.adminLayout;
        AppHelper.appId = data.appId;
        AppHelper.homeLayout = data.homeLayout;
        AppHelper.mightyAppId = data.mightyAppId;
        AppHelper.myBranchId = data.myBranchId;
        AppHelper.defaultCacheTimeoutSeconds = data.defaultCacheTimeoutSeconds;
        AppHelper.refreshTokens = data.refreshTokens;
        AppHelper.tokenExpiryOffsetSeconds = data.tokenExpiryOffsetSeconds;
        // console.log("app helper", AppHelper)
    }



}
